<template>
    <div class="col-xl-5 box-col-6 proorder-xl-3 xl-100">
        <div class="card">
            <div class="card-body">
                <div class="pro-group pt-0 border-0">
                    <div class="product-page-details mt-0">
                        <h3>{{ products.name }}</h3>
                        <div class="pro-review">
                            <div class="d-flex">
                                <rate :length="5" :value="2" /><span>(250 review)</span>
                            </div>
                        </div>
                    </div>
                    <div class="product-price"> ${{ products.price }}
                        <del>${{ products.discountPrice }} </del>
                    </div>
                    <div class="color-selector">
                        <ul>
                            <li class="active white"></li>
                            <li class="bg-primary"> </li>
                            <li class="bg-secondary"></li>
                            <li class="bg-success"></li>
                            <li class="bg-warning"></li>
                            <li class="bg-danger"></li>
                        </ul>
                    </div><router-link :to="'/ecommerce/cart'" class="btn btn-secondary mt-0"
                        @click="addToCart(products)"><i class="fa fa-shopping-cart me-2"></i>Buy
                        Now</router-link>
                </div>
                <div class="pro-group">
                    <p>{{ products.discription }}</p>
                </div>
                <div class="pro-group">
                    <div class="row">
                        <div class="col-md-6">
                            <table>
                                <tbody>
                                    <tr>
                                        <td> <b>Availability &nbsp;: &nbsp;</b></td>
                                        <td class="txt-success">In stock</td>
                                    </tr>
                                    <tr>
                                        <td> <b>Brand
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>
                                        </td>
                                        <td>Pixelstrap</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-6">
                            <table>
                                <tbody>
                                    <tr>
                                        <td> <b>Seller &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;:
                                                &nbsp;&nbsp;&nbsp;</b></td>
                                        <td>ABC</td>
                                    </tr>
                                    <tr>
                                        <td> <b>Fabric &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;:
                                                &nbsp;&nbsp;&nbsp;</b></td>
                                        <td>Cotton </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <productSocial />
                <div class="pro-group pb-0">
                    <div class="pro-shop">
                        <router-link :to="'/ecommerce/cart'" class="btn btn-primary m-r-10" @click="addToCart(products)"> <i
                                class="fa fa-shopping-basket me-2"></i>Add To Cart</router-link><router-link
                            class="btn btn-danger" :to="'/ecommerce/wishlist'"><i class="fa fa-heart me-2"></i>Add To
                            WishList </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import productSocial from "./productSocial.vue"
import productPage from "@/mixins/commen/productPage"
export default {
    mixins: [productPage],
    data() {
        return {
            counter: 1, modalShow: false, activeTab: 'fabric',
        }
    },
    components: { productSocial },
    methods: {
        addToCart: function (product, qty) {
            product.quantity = qty ? qty : 1;
            this.$store.dispatch("product/addToCart", product);
        },
    }
}
</script>